import { AxiosResponse } from "axios";
import { SERVERURL } from "../globals/constants";
import { Profile } from "../models/Profile";
import { Set } from "../models/global/Set";
import { QuoteStore } from "../stores/useQuote";
import { Quote } from "../models/Quote";
import {
  AddQuoteItemDto,
  CreateQuoteDto,
  UpdateQuoteDto,
} from "../models/dto/QuoteDTO";
import axios from "./axiosConfig";
import { HTTPResponse } from "../models/global/HTTPResponse";

export const getAllQuotes = async (set: Set<QuoteStore>, user: Profile) => {
  const response = await axios.get<Quote[]>(`${SERVERURL}/quote/getall`, {
    headers: {
      Authorization: `Bearer ${user.token}`,
      "Content-Type": "application/json;charset=UTF-8",
    },
  });

  set((state) => ({ ...state, quotes: response.data }));

  return response.data;
};

export const getQuote = async (user: Profile, quoteId: number): Promise<HTTPResponse<Quote>> => {
  const response = await axios.get<Quote>(`${SERVERURL}/quote/get/${quoteId}`, {
    headers: {
      Authorization: `Bearer ${user.token}`,
      "Content-Type": "application/json;charset=UTF-8",
    },
  });

  return { status: response.status, data: response.data };
};

export const createQuote = async (
  user: Profile,
  quote: CreateQuoteDto
): Promise<HTTPResponse<Quote>> => {
  try {
    const response: AxiosResponse = await axios.post(
      `${SERVERURL}/quote/create`,
      quote,
      {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          Authorization: `Bearer ${user.token}`,
        },
      }
    );
    return { status: response.status, data: response.data };
  } catch (error: any) {
    if (error.response) {
      return error.response.status;
    } else {
      return Promise.reject(error.message);
    }
  }
};

export const editQuoteItem = async (
  user: Profile,
  quoteId: number,
  quoteItemId: number,
  quoteItem: AddQuoteItemDto
): Promise<number> => {
  try {
    const response: AxiosResponse = await axios.put(
      `${SERVERURL}/quote/${quoteId}/editItem/${quoteItemId}`,
      quoteItem,
      {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          Authorization: `Bearer ${user.token}`,
        },
      }
    );
    return response.status;
  } catch (error: any) {
    if (error.response) {
      return error.response.status;
    } else {
      return Promise.reject(error.message);
    }
  }
};

export const deleteQuoteItem = async (
  user: Profile,
  quoteId: number,
  quoteItemId: number,
): Promise<number> => {
  try {
    const response: AxiosResponse = await axios.delete(
      `${SERVERURL}/quote/${quoteId}/removeItem/${quoteItemId}`,
      {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          Authorization: `Bearer ${user.token}`,
        },
      }
    );
    return response.status;
  } catch (error: any) {
    if (error.response) {
      return error.response.status;
    } else {
      return Promise.reject(error.message);
    }
  }
};

export const updateQuote = async (
  user: Profile,
  quote: UpdateQuoteDto,
  quoteId: number
): Promise<number> => {
  try {
    const response: AxiosResponse = await axios.put(
      `${SERVERURL}/quote/update/${quoteId}`,
      quote,
      {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          Authorization: `Bearer ${user.token}`,
        },
      }
    );
    return response.status;
  } catch (error: any) {
    if (error.response) {
      return error.response.status;
    } else {
      return Promise.reject(error.message);
    }
  }
};

export const deleteQuote = async (user: Profile, quoteId: number) => {
  try {
    const response: AxiosResponse = await axios.delete(
      `${SERVERURL}/quote/remove/${quoteId}`,
      {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          Authorization: `Bearer ${user.token}`,
        },
      }
    );
    return response.status;
  } catch (error: any) {
    if (error.response) {
      return error.response.status;
    } else {
      return Promise.reject(error.message);
    }
  }
};

export const addQuoteItem = async (
  user: Profile,
  quoteId: number,
  quoteItem: AddQuoteItemDto
): Promise<number> => {
  try {
    const response: AxiosResponse = await axios.post(
      `${SERVERURL}/quote/${quoteId}/addItem`,
      quoteItem,
      {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          Authorization: `Bearer ${user.token}`,
        },
      }
    );
    return response.status;
  } catch (error: any) {
    if (error.response) {
      return error.response.status;
    } else {
      return Promise.reject(error.message);
    }
  }
};
